import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import {
  AuthenticationGuard,
  AuthenticationService
} from '@app/core/authentication';
import {
  ApiPrefixInterceptor,
  ErrorHandlerInterceptor,
  HttpService
} from '@app/core/http';
import { LocalStorageService } from '@app/core/local-storage.service';
import { RouteReusableStrategy } from '@app/core/route-reusable-strategy';
import {
  ErrorMessageService,
  UserService,
  ProductService,
  CategoryService,
  WarehouseService,
  UtilService,
  OrderService,
  ExpenseService,
  ReporteVentaService,
  ReporteGastoService,
  UnityService
} from '@app/core/service';
import { FileService } from './service/file.service';
import { ReporteService } from './service/reporte.service';
import { UnidadService } from './service/unidad.service';
import { VentaService } from './service/venta.service';
import { PagoService } from './service/pago.service';
import { ProformaService } from './service/proforma.service';

@NgModule({
  imports: [CommonModule, HttpClientModule, RouterModule],
  declarations: [],
  providers: [
    LocalStorageService,
    AuthenticationService,
    AuthenticationGuard,
    ApiPrefixInterceptor,
    ErrorHandlerInterceptor,
    UserService,
    WarehouseService,
    CategoryService,
    ProductService,
    OrderService,
    FileService,
    ReporteService,
    UtilService,
    ExpenseService,
    ReporteVentaService,
    ReporteGastoService,
    UnityService,
    ErrorMessageService,
    UnidadService,
    PagoService,
    ProformaService,
    VentaService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true
    },
    {
      provide: HttpClient,
      useClass: HttpService
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy
    }
  ]
})
export class CoreModule {}
